import { render, staticRenderFns } from "./CollectorWork.vue?vue&type=template&id=90b3a7ac&scoped=true&"
import script from "./CollectorWork.vue?vue&type=script&lang=js&"
export * from "./CollectorWork.vue?vue&type=script&lang=js&"
import style0 from "./CollectorWork.vue?vue&type=style&index=0&id=90b3a7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b3a7ac",
  null
  
)

export default component.exports